import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface ConsumerIdentificationThreshold {
  country: string;
  threshold: number;
}

@Injectable({ providedIn: 'root' })
export class FiscalService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/v1/fiscal`;

  constructor(private http: HttpClient) {}

  getConsumerIdentificationThreshold(): Observable<ConsumerIdentificationThreshold> {
    return this.http
      .get<any>(`${this.baseUrl}/consumer-identification-threshold`)
      .pipe(
        map(response => {
          const body = response?.requestResult ?? response;
          return {
            country: body.country ?? 'AR',
            threshold: Number(body.threshold ?? 0)
          } as ConsumerIdentificationThreshold;
        })
      );
  }
}
